import * as React from "react";
import { useDispatch } from "@teamprevent/customer-redux";

import { loadCustomerUsers } from "../actions";

import All from "./All";
import { Detail } from "./Detail";
import { Edit } from "./Edit";
import { Create } from "./Create";

import { Fragment } from "redux-little-router";

const Base: React.FunctionComponent = () => {
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(loadCustomerUsers(true));
    }, [dispatch]);

    return (
        <div>
            <Fragment forRoute="/" withConditions={l => l.params.customerUserId === undefined}>
                <div>
                    <All />
                    <Create />
                </div>
            </Fragment>
            <Fragment forRoute="/:customerUserId">
                <div>
                    <Detail />
                    <Edit />
                </div>
            </Fragment>
        </div>
    );
};

export default Base;
